import { ErrorResponse } from "../../app/models/api/errorResponse";

export const getErrorMsgFromStringArray = (errors: string[], separator: string) => {
    if (errors.length < 1) {
        return "";
    }
    return errors.join(separator);
};

export const getErrorMsgFromResponse = (response?: ErrorResponse) => {
    const errorDetails = response?.data?.detail;
    const errors = response?.data?.errors;
    let res = "";
    if (errorDetails) {
        res += errorDetails;
    }

    if (errors && errors.length > 0) {
        if (res) {
            res += " ";
        }
        res += errors.join(" ");
    }
    return res;
};

export const getBadRequestErrorListFromResponse = (response?: ErrorResponse) => {
    const errors = response?.data?.errors;
    if (!errors || errors.length === 0 || response.status !== 400) {
        return null;
    }
    return errors;
};
